import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Add from '@mui/icons-material/Add';
import ArrowBack from '@mui/icons-material/ArrowBack';
import PageHeader from '../../../Components/PageHeader';
import TablePeo from '../../../Components/TablePeo';
import { useApiGet } from '../../../utils/httpClientTs';
import { listVendors } from '../../../endpoints/chapterSupplies';

const headCells = [
  { id: 'name', firstCell: true, label: 'Name', width: '30%' },
  { id: 'contact_name', label: 'Contact', width: '20%' },
  { id: 'city', label: 'City', width: '15%' },
  {
    id: 'created_at',
    label: 'Created',
    width: '35%',
    format: (value: unknown) =>
      value
        ? new Date(value as string).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          })
        : '',
  },
];

export default function VendorList() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [order, setOrder] = useState<'asc' | 'desc'>('desc');
  const [orderBy, setOrderBy] = useState('created_at');

  const limit = rowsPerPage;
  const offset = page * rowsPerPage;

  const { data, isFetching } = useApiGet(
    ['chapter-supplies-vendors', limit, offset],
    () => listVendors({ limit, offset }),
    {
      enabled: true,
      retry: 1,
      refetchOnMount: 'always',
    }
  );

  const vendors = data?.vendors ?? [];
  const handleRowClick = (_event: React.MouseEvent, rowId: string | number) => {
    navigate(`/chapter-supplies-management/vendors/${rowId}`);
  };

  return (
    <Grid container paddingLeft={2} paddingRight={2}>
      <Grid item xs={12}>
        <PageHeader
          title="Vendors"
          leftDom={
            <Button
              startIcon={<ArrowBack />}
              onClick={() => navigate('/chapter-supplies-management')}
            >
              Back
            </Button>
          }
          rightDom={
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() =>
                navigate('/chapter-supplies-management/vendors/create')
              }
            >
              Add vendor
            </Button>
          }
          subtitle={undefined}
        />
      </Grid>
      <TablePeo
        data={vendors}
        isFetching={isFetching}
        headCells={headCells}
        handleRowClick={handleRowClick}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        emptyMessage="No vendors yet. Create one to get started."
      />
    </Grid>
  );
}
